import brandTheme from '../../../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

const getOptions = ({
  title = '',
  yAxisTitle = '',
  tooltipValueSuffix = '',
  series = [],
  categories = [],
}) => ({
  chart: {
    type: 'column',
  },
  title: {
    text: title,
  },
  colors: [colors.primary],
  credits: false,
  legend: {
    enabled: false,
  },
  allowDecimals: false,
  rangeSelector: {
    selected: 1,
  },
  navigator: {
    enabled: false,
  },
  xAxis: {
    categories,
    crosshair: true,
  },
  yAxis: {
    title: {
      text: yAxisTitle,
    },
  },
  tooltip: {
    valueSuffix: tooltipValueSuffix,
  },
  series,
})
export default getOptions
